<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="23"
    height="22"
    viewBox="0 0 23 22"
    fill="none"
  >
    <path
      d="M11.3259 20.1673C16.4549 20.1673 20.6128 16.0633 20.6128 11.0007C20.6128 5.93804 16.4549 1.83398 11.3259 1.83398C6.19693 1.83398 2.03906 5.93804 2.03906 11.0007C2.03906 16.0633 6.19693 20.1673 11.3259 20.1673Z"
      fill="white"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.3262 14.6667V11"
      stroke="#FD4D4D"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.3262 7.33398H11.3362"
      stroke="#FD4D4D"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: "IconCritical",
};
</script>

<style></style>
